import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';
export const ImagePreviewSmallHeight = '120px';
export const ImagePreviewHeight = '240px';

export const ImageBoxStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  my: { sm: '400' },
})`
  ${({ theme }) => css`
    width: 49%;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    border-radius: ${theme.spacings[400]};
    @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
      width: 48%;
    }
  `};
`;

export const ImageStyled = styled.img`
  height: ${ImagePreviewHeight};
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    height: ${ImagePreviewSmallHeight};
  }
  ${({ theme }) => css`
    width: 100%;
    border-radius: 0 0 ${theme.spacings[300]} ${theme.spacings[300]};
  `};
`;
